import { PJ_PANEL_URL, authRequest, publicRequest } from '~/service/api'
import { PJPanelHrpcDeclaration, PJPanelPublicHrpcDeclaration } from '@mutual-services/pj-panel-hrpc'
import { createApiOperationCreator } from '~/utils/redux-rest-api/operationHelper'

const createApiOperation = createApiOperationCreator(authRequest)
const createPublicApiOperation = createApiOperationCreator(publicRequest)

const createHrpcOperation = <TMethod extends keyof PJPanelHrpcDeclaration>(method: TMethod) => {
  return createApiOperation<PJPanelHrpcDeclaration[TMethod]['input'], PJPanelHrpcDeclaration[TMethod]['output']>((params) => ({
    method: 'POST',
    url: `${PJ_PANEL_URL}/hrpc`,
    data: {
      method,
      ...(params ? { params } : {})
    }
  }))
}

const createPublicHrpcOperation = <TMethod extends keyof PJPanelPublicHrpcDeclaration>(method: TMethod) => {
  return createPublicApiOperation<PJPanelPublicHrpcDeclaration[TMethod]['input'], PJPanelPublicHrpcDeclaration[TMethod]['output']>((params) => ({
    method: 'POST',
    url: `${PJ_PANEL_URL}/public/hrpc`,
    data: {
      method,
      ...(params ? { params } : {})
    }
  }))
}

// PUBLIC
export const resetPassword = createPublicHrpcOperation('resetPassword')
export const resetAccountPassword = createPublicHrpcOperation('resetAccountPassword')
export const checkIfAccountExists = createPublicHrpcOperation('checkIfAccountExists')
export const getCompaniesBasicData = createPublicHrpcOperation('getCompaniesBasicData')
export const checkIfPjHasPendencies = createPublicHrpcOperation('checkIfPjHasPendencies')
export const validateResetPasswordToken = createPublicHrpcOperation('validateResetPasswordToken')
export const createPjAccountWithPendencies = createPublicHrpcOperation('createPjAccountWithPendencies')

// INTERNAL
export const getMe = createHrpcOperation('getMe')
export const updatePhone = createHrpcOperation('updatePhone')
export const updateEmail = createHrpcOperation('updateEmail')
export const pjSetAddress = createHrpcOperation('pjSetAddress')
export const validateCode = createHrpcOperation('validateCode')
export const pjSetSocialMedia = createHrpcOperation('pjSetSocialMedia')
export const getAccountByCnpj = createHrpcOperation('getAccountByCnpj')
export const sendDocumentsLead = createHrpcOperation('sendDocumentsLead')
export const getInitialAnalysis = createHrpcOperation('getInitialAnalysis')
export const getAddressByZipcode = createHrpcOperation('getAddressByZipcode')
export const completePendencies = createHrpcOperation('completePendencies')
export const sendCreateAccountLead = createHrpcOperation('sendCreateAccountLead')
export const createInitialAnalysis = createHrpcOperation('createInitialAnalysis')
export const updatePJAnalysisStatus = createHrpcOperation('updatePJAnalysisStatus')
export const generateValidationCode = createHrpcOperation('generateValidationCode')
export const sendRenewedValidationCode = createHrpcOperation('sendRenewedValidationCode')
export const addDocumentOnDocumentGroup = createHrpcOperation('addDocumentOnDocumentGroup')
export const changeDocumentsGroupStatus = createHrpcOperation('changeDocumentsGroupStatus')
export const getDocumentsGroupsByAccountId = createHrpcOperation('getDocumentsGroupsByAccountId')
export const createSerasaScoreAccountDocuments = createHrpcOperation('createSerasaScoreAccountDocuments')
export const updatePhoneAndRenewValidationCode = createHrpcOperation('updatePhoneAndRenewValidationCode')
export const updateEmailAndRenewValidationCode = createHrpcOperation('updateEmailAndRenewValidationCode')
